// extracted by css-extract-rspack-plugin
export default {"stats":"stats-YBy6Dg","lastActivity":"lastActivity-buOhL1 text-sm-light","unread":"unread-nEVfVN"};